import React, { useCallback, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../services/api.js';
import QuickPrintDialog from '../components/QuickPrintDialog.js';
import { buildVisitPayload } from '../components/vehicle-details/vehicleDetailsPrint.js';
const labels = { invoice: 'فاتورة', quote: 'عرض سعر', diagnosis: 'تقرير تشخيص', receipt: 'سند زيارة' };
// Read-only legacy route: no invented invoice numbers or editable issued facts.
export default function DocumentPrint() {
    const [params] = useSearchParams();
    const [open, setOpen] = useState(true);
    const vehicleId = params.get('vehicleId');
    const visitId = params.get('visitId');
    const docType = params.get('type') || 'invoice';
    const supported = Boolean(labels[docType] && vehicleId && visitId);
    const build = useCallback(async () => {
        const [vehicleResponse, visitsResponse] = await Promise.all([
            api.get('/vehicles/' + encodeURIComponent(vehicleId)),
            api.get('/vehicles/' + encodeURIComponent(vehicleId) + '/visits'),
        ]);
        const raw = visitsResponse.data;
        const rows = Array.isArray(raw) ? raw : raw?.visits;
        const visit = rows?.find((row) => String(row.id) === visitId);
        if (!visit) throw new Error('بيانات الزيارة غير متاحة. افتح المستند من ملف المركبة.');
        return buildVisitPayload({ docType, visit, vehicle: vehicleResponse.data?.vehicle || vehicleResponse.data });
    }, [docType, vehicleId, visitId]);
    return <main dir="rtl" className="space-y-4 p-6">
        <h1 className="text-2xl font-bold">طباعة مستند الزيارة</h1>
        <p>الفاتورة تُقرأ من الزيارة المعتمدة برقم إصدارها المحفوظ. لا يمكن تعديل مبالغها داخل نافذة الطباعة.</p>
        {!supported && <p role="alert">رابط المستند غير مكتمل أو نوعه غير مدعوم. افتح الزيارة المطلوبة من ملف المركبة ثم اختر الطباعة. لا يتم إنشاء فاتورة بديلة أو أرقام مؤقتة.</p>}
        {supported && <button type="button" onClick={() => setOpen(true)}>فتح معاينة {labels[docType]}</button>}
        <Link className="block underline" to="/vehicles">العودة إلى المركبات</Link>
        {supported && <QuickPrintDialog open={open} title={labels[docType]} payloadBuilder={build} onClose={() => setOpen(false)} />}
    </main>;
}
